import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Bike } from 'lucide-react';
export function ProductReveal() {
  return <section className="py-12 md:py-16 px-4 bg-slate-950 relative overflow-hidden" data-id="element-338">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-339" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-340">
        <FadeIn data-id="element-341">
          <Bike className="w-12 h-12 text-amber-500 mx-auto mb-4" strokeWidth={1.5} data-id="element-342" />
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-3 tracking-tight" data-id="element-343">
            PROTORRENDA 4-12
          </h2>
          <p className="text-2xl md:text-3xl text-amber-500 font-serif italic mb-2" data-id="element-344">
            El Método de los 4 Pilares
          </p>
          <p className="text-lg text-slate-400" data-id="element-345">
            6 Tomos + 4 Bonos — Para el ciclista amateur argentino
          </p>
        </FadeIn>
      </div>
    </section>;
}